export const biConstants = {
  BI_END_POINT: 'engage',
  BI_ENGAGE_SRC: 5,
};

export const biEventsMap = {
  EXPAND_CHAT: { evid: 523 },
  SEND_MESSAGE: { evid: 524 },
  REALTIME_ACTIVITY: { evid: 530 },
  ADD_ATTACHMENT_CLICK: { evid: 563 },
  IMAGE_CLICK: { evid: 772 },
  CHAT_DISPLAYED: { evid: 701 },
  CALL_TO_ACTION_CLICK: { evid: 706 },
  LCF_SUBMISSION: { evid: 766 },
  COPY_COUPON_CODE: { evid: 767 },
  DEBUG: { evid: 572 },
};

export const BI_EVENTS: any = Object.keys(biEventsMap).reduce(
  (acc, key) => ({ ...acc, [key]: key }),
  {},
);
